import type { FunctionComponent, PropsWithChildren } from 'react';
import { useEffect, useRef } from 'react';

interface IDashboardBannerWrapperProps extends PropsWithChildren {
    onBannerHeightChange: (height: number) => void;
}

export const DashboardBannerWrapper: FunctionComponent<IDashboardBannerWrapperProps> = ({ children, onBannerHeightChange }) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const updateDimensions = () => {
            if (ref.current) onBannerHeightChange(ref.current.clientHeight);
        };

        updateDimensions();

        const resizeObserver = new ResizeObserver(updateDimensions);
        if (ref.current) resizeObserver.observe(ref.current);

        return () => {
            resizeObserver.disconnect();
            onBannerHeightChange(0);
        };
    }, [onBannerHeightChange]);

    return (
        <div ref={ref} style={{ padding: '15px' }}>
            {children}
        </div>
    );
};
